import { AbstractControl, ValidatorFn } from '@angular/forms';

export function ValidateExternalLink(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } =>
    control.value.startsWith('https://') || control.value.startsWith('http://') || control.value === ''
      ? null
      : { startLinkError: true };
}
